import React from "react";
import { Stack } from "./Flexify";

const Page = ({ children }) => {
  return (
    <Stack maxWidth="1280px" margin="auto" padding={['16px ', '12px 0 50px 12px']}>
      {children}
    </Stack>
  );
};

export default Page;
